<template>
  <div>
    <el-form :model="ruleForm" ref="ruleForm" label-width="auto" class="demo-ruleForm">

      <el-form-item prop="userName">
        <el-input v-model="ruleForm.userName" :maxlength='15' clearable placeholder="请输入昵称">
          <i slot="prefix" class="el-input__icon el-icon-user"></i>
        </el-input>
      </el-form-item>

      <el-form-item prop="telephone">
        <el-input v-model="ruleForm.telephone" clearable placeholder="请输入手机号">
          <i slot="prefix" class="el-input__icon el-icon-phone-outline">
          </i>
        </el-input>
      </el-form-item>

      <el-form-item prop="code">
        <el-input :maxlength='6' v-model="ruleForm.code" placeholder="请输入短信验证码">
          <i slot="prefix" class="el-input__icon el-icon-message">
          </i>
        </el-input>
        <el-link :underline="false" type="success" v-if="codeState == 1" @click="getSMSCode(1)">发送验证码</el-link>
        <el-link :underline="false" type="success" v-if="codeState == 2" @click="getSMSCode(2)">{{second}}s后重新发送
        </el-link>
      </el-form-item>

      <!-- 记住状态 -->
      <div class="pass_state">
        <div class="pass_state_lt">
          <el-checkbox v-model="ruleForm.checked">
            勾选同意
          </el-checkbox>
          <el-link @click="goAgreement" type="success">《用户服务协议》</el-link>
        </div>
      </div>

      <el-form-item class="form_item_btn">
        <el-button class="btn_submit" type="success" @click="submitForm('ruleForm')">下一步</el-button>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
import {
  sendSms,
  unmatched,
  getUserInfoByTel,
} from "@/network/loginRequest/api";
import utils from "@/util/index";

export default {
  data() {
    return {
      ruleForm: {
        userName: "",
        telephone: "",
        code: "",
        checked: false,
      },
      second: 60,
      codeState: 1, // 1--未发送，2--已发送
    };
  },
  methods: {
    //验证
    submitForm() {
      let form = this.ruleForm;
      //验证手机号
      let RegPhone = new RegExp(
        /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/
      );

      //验证昵称
      let regUserName = new RegExp(/^[\u4E00-\u9FA5A-Za-z0-9_]+$/);

      if (form.userName == "") {
        utils.tips("warning", "昵称不能为空");
      } else if (!regUserName.test(form.userName)) {
        utils.tips("warning", "昵称不能包含特殊字符");
      } else if (!RegPhone.test(form.telephone)) {
        utils.tips("warning", "请输入正确的手机号码");
      } else if (form.code == "") {
        utils.tips("warning", "请输入验证码");
      } else if (!form.checked) {
        utils.tips("warning", "请同意协议");
      } else {
        //验证验证码是否和手机符合
        let fd = new FormData();
        fd.append("phone", form.telephone);
        fd.append("telephone", form.telephone);
        fd.append("code", form.code);
        unmatched(fd).then((res) => {
          if (res.data) {
            //匹配时成功返回false
            this.$bus.ruleForm = form;
            this.$emit("update:isShow", false);
          } else {
            utils.tips("error", "请确保验证码输入正确");
          }
        });
      }
    },

    //发送验证码事件
    getSMSCode(type) {
      //验证手机号
      let RegPhone = new RegExp(
        /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/
      );
      var userName = this.ruleForm.userName;
      var tel = this.ruleForm.telephone;
      var checked = this.ruleForm.checked;

      //判断昵称号 是否为空
      if (userName == "") {
        utils.tips("warning", "请输入昵称");
        return false;
      }

      //判断手机号 是否为空
      if (tel == "") {
        utils.tips("warning", "请输入手机号码");
        return false;
      }

      //校验是否为手机号
      if (!RegPhone.test(tel)) {
        utils.tips("warning", "请输入正确的手机号码");
        return false;
      }

      if (checked == "") {
        utils.tips("warning", "请勾选同意用户协议");
        return false;
      }

      //判断手机号是否注册过
      if (type == 1) {
        getUserInfoByTel(tel).then((res) => {
          if (res.data.state == 1) {
            utils.tips("warning", "该手机号已注册过");
            return false;
            //发送验证码
          } else if (res.data.state == 2) {
            sendSms(tel, true)
              .then((res) => {
                if (res.data.state == "1") {
                  utils.tips("success", "发送成功！");
                  this.codeState = 2;
                  let that = this;
                  let t = setInterval(() => {
                    if (this.second == 0) {
                      that.second = 60;
                      clearInterval(t);
                      this.codeState = 1;
                    } else {
                      that.second = that.second - 1;
                    }
                  }, 1000);
                } else {
                  utils.tips("info", res.data.code);
                }
              })
              .catch((err) => {
                utils.tips("error", err);
              });
          }
        });
      }
    },

    //前往用户协议
    goAgreement() {
      let newURL = window.location.origin + "/#/agreement";
      window.open(newURL);
    },
  },
};
</script>

<style lang='less' scoped>
.el-form {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .form_item_btn {
    margin-top: 10px;
  }

  .el-form-item:nth-child(3) {
    margin-bottom: 10px;
  }

  .el-form-item {
    width: 100%;
    margin-bottom: 30px;

    .el-form-item__content {
      position: relative;

      .el-link {
        position: absolute;
        top: 0;
        right: 5px;
      }
    }

    .btn_submit {
      width: 100%;
      color: #5b9974;
      background-color: #fff;
      border-color: #24ba58;
    }

    .el-button--success:active {
      background-color: skyblue;
      border-color: skyblue;
    }

    /deep/.el-input__inner:focus {
      border-color: #24ba58;
    }
  }
}

//UI样式修改
.pass_state {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  width: 100%;

  .pass_state_rt > a:nth-child(2) {
    margin-left: 20px;
  }

  .pass_state_rt > a {
    color: #24ba58;
  }

  /deep/.el-checkbox__inner {
    border: 1px solid #878787;
  }

  /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
    color: #24ba58;
  }

  /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #24ba58;
    border-color: #24ba58;
  }
}
</style>